module.exports = __webpack_public_path__ + "img/f566722a06f456bf31d48d23c7facc0b.f566722a.png";